import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { getInformation } from '../../constants/ci-information.constant';
import { environment } from '../../../../../environments/environment';
import { RouterModule } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-gallery-banner',
  standalone: true,
  imports: [NgFor, NgIf,RouterModule],
  templateUrl: './gallery-banner.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DialogService
  ]
})
export class GalleryBannerComponent implements OnInit {

  @Input()
  public slug!: string;

  @Input()
  public color!: string;

  @Input()
  public scrollSectionId!: string;

  public data: any;

  constructor(public dialogService: DialogService) {
  }

  ngOnInit(): void {
    this.data = getInformation(this.slug);

    this.color? this.color = this.color: this.color = 'purple'
  }

  public openLink(): void {
    window.open(this.data.link);
  }

  public getRoute() {
    return environment.baseLink + '/' + this.data.slug;
  }

  public scrollToFeatureSection(): any {
    const element = document.getElementById(this.scrollSectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
